module.exports = __webpack_public_path__ + "static/img/95-2.2b950e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/95-2.jpg
// module id = 84b4
// module chunks = 0